import { TextStyleProps } from "@twilio-paste/core";
import { BoxStyleProps } from "@twilio-paste/core/box";

export const messageAgentJoinDateContainerStyles: BoxStyleProps = {
    marginBottom: "space0"
};

export const messageAgentJoinContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "space0",
    marginBottom: "space60"
};

export const messageAgentJoinLineStyles: BoxStyleProps = {
    flex: "1",
    borderStyle: "solid",
    borderColor: "colorBorderWeak",
    borderWidth: "borderWidth0",
    borderTopWidth: "borderWidth10"
};

export const messageAgentJoinTextStyles: TextStyleProps = {
    fontSize: "fontSize20",
    marginLeft: "space40",
    marginRight: "space40",
    color: "colorText",
    textAlign: "center"
};
